<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1> -->
<div mat-dialog-content>
  <p>Send an invitation to...</p>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input 
        matInput 
        type='email' 
        [(ngModel)]="data.email">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button [mat-dialog-close]="data.email" cdkFocusInitial>Send</button>
</div>
